var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 106.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.08,6.01C10.14,2,15.33,0,21.66,0s11.52,2,15.58,6.01c4.05,4.01,6.08,9.37,6.08,16.1s-2.03,12.24-6.08,16.25c-4.06,4.01-9.25,6.01-15.58,6.01s-11.52-2-15.58-6.01C2.03,34.35,0,28.93,0,22.11S2.03,10.01,6.08,6.01Zm7.64,5.79c-1.93,2.32-2.89,5.76-2.89,10.31s.96,8.01,2.89,10.39c1.93,2.37,4.57,3.56,7.94,3.56s6.03-1.21,8.01-3.64c1.98-2.42,2.97-5.86,2.97-10.31s-.99-7.99-2.97-10.31c-1.98-2.32-4.65-3.49-8.01-3.49s-6.01,1.16-7.94,3.49ZM86.65,1.63L26.56,105.19h-13.35L73.29,1.63h13.35Zm-23.74,66.84c4.05-4.01,9.25-6.01,15.58-6.01s11.5,2,15.5,6.01c4.01,4,6.01,9.42,6.01,16.25s-2,12.12-6.01,16.17c-4.01,4.06-9.18,6.08-15.5,6.08s-11.52-2-15.58-6.01c-4.06-4.01-6.08-9.42-6.08-16.25s2.03-12.24,6.08-16.25Zm7.42,5.93c-1.98,2.32-2.97,5.76-2.97,10.31s.99,7.84,2.97,10.16c1.98,2.32,4.65,3.49,8.01,3.49s6.03-1.16,8.01-3.49c1.98-2.32,2.97-5.71,2.97-10.16s-.99-7.99-2.97-10.31c-1.98-2.32-4.65-3.49-8.01-3.49s-6.03,1.16-8.01,3.49Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/percentage.a1fc236b2453496a189fa40cbe9d9e9c.svg";
export { ForwardRef as ReactComponent };